import * as XLSX from 'xlsx'
export default {
  data() {
    return {
      loading: false,
      usuarios: [],

      usuarios_general: [],
      usuarios_activos: [],
      usuarios_suspendidos: [],
      usuarios_pre_cancelados: [],
      usuarios_sin_suscripciones: [],
      search: "",
      headers: [
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
        },
        {
          text: "CUI/DPI",
          align: "center",
          sortable: true,
          value: "cui"
        },
        {
          text: "NIT",
          align: "center",
          sortable: true,
          value: "nit",
        },

        {
          text: "Dirección",
          align: "center",
          sortable: true,
          value: "direccion",
        },
        {
          text: "Teléfono",
          align: "center",
          sortable: true,
          value: "telefono[0].telefono",
        },
        {
          text: "Correo",
          align: "center",
          sortable: true,
          value: "correo[0].correo"
        },
      
        {
          text: "Acciones",
          align: "center",
          sortable: false,
          value: "estado_usuario",
        },
      ],

      tabs: [
        { tab: 'General', content: 'general' },
        { tab: 'Activos', content: 'activos' },
        { tab: 'Suspendidos', content: 'suspendidos' },
        { tab: 'Pre cancelados', content: 'pre_cancelados' },
        { tab: 'Sin suscripción', content: 'sin_suscripcion' },
      ],

      tab: '',

      dialog_modificar_correo: false,
      item_correo_aux: '',
      correo_nuevo: '',
      loading_correos: false,

      dialog_modificar_contrasena: false,
      loading_contrasena: false,
      item_usuario_aux: '',

      contrasena_nueva: '',
    };
  },
  async created() {
    await this.getUsuariosEstado();
  },
  methods: {
    async editItem(item) {
      this.loading = true;
      try {
        let r =
          await this.$store.state.services.administradorService.updateEmpleados(
            item
          );
        if (r.status === 200) {
          await this.getUsuarios();
          this.$toast.success(
            "SE HA ACTUALIZADO EL USUARIO EXITOSAMENTE"
          );
        } else {
          this.$toast.error(
            "Ocurrió un error al intentar actualizar el usuario"
          );
        }
        this.loading = false;
      } catch (error) {
        this.$toast.error(
          "Ocurrió un error al intentar actualizar el usuario"
        );
        this.loading = false;
      }
    },

    exportarExcel() {
      let info = [];
      this.usuarios.forEach(element => {
        let data = {
          NOMBRE: element.nombre,
          CUI: element.cui,
          NIT: element.nit,
          PASSWORD_SAT: element.password_sat,
          DIRECCION: element.direccion,
          TELEFONO: (element.telefono.length > 0) ? element.telefono[0].telefono : '',
          CORREO: (element.correo.length > 0) ? element.correo[0].correo : '',
          DIA_DECLARACION: element.fecha_declaracion,
          ULTIMOS_NUMEROS_TARJETA: (element.forma_pago.length > 0) ? element.forma_pago[0].ultimos_numeros : '',
          NOMBRE_PORTADOR: (element.forma_pago.length > 0) ? element.forma_pago[0].nombre_portador : '',
          EMPLEADO: element.empleado
        }
        info.push(data);
      });

      let data = XLSX.utils.json_to_sheet(info)
      const workbook = XLSX.utils.book_new()
      const filename = 'Estado_usuarios'
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },

    async getUsuariosEstado() {
      this.loading = true;
      try {
        let r =
          await this.$store.state.services.administradorService.getUsuariosEstado();
        console.log("usuarios");
        console.log(r);

        r.data.data.general.filter((x) => {
          let n1 = x.primer_nombre === null ? '' : x.primer_nombre ;
          let n2 = x.segundo_nombre === null ? '' : x.segundo_nombre ;
          let a1 = x.primer_apellido === null ? '' : x.primer_apellido ;
          let a2 = x.segundo_apellido === null ? '' : x.segundo_apellido;
 
           x.nombre = n1 + ' ' + n2 + ' ' + a1 + ' ' + a2;
        });

        r.data.data.activo.filter((x) => {
          let n1 = x.primer_nombre === null ? '' : x.primer_nombre ;
          let n2 = x.segundo_nombre === null ? '' : x.segundo_nombre ;
          let a1 = x.primer_apellido === null ? '' : x.primer_apellido ;
          let a2 = x.segundo_apellido === null ? '' : x.segundo_apellido;
 
           x.nombre = n1 + ' ' + n2 + ' ' + a1 + ' ' + a2;
 
        });

        r.data.data.precancelado.filter((x) => {
          let n1 = x.primer_nombre === null ? '' : x.primer_nombre ;
          let n2 = x.segundo_nombre === null ? '' : x.segundo_nombre ;
          let a1 = x.primer_apellido === null ? '' : x.primer_apellido ;
          let a2 = x.segundo_apellido === null ? '' : x.segundo_apellido;
 
           x.nombre = n1 + ' ' + n2 + ' ' + a1 + ' ' + a2;
        });

        r.data.data.sin_sub.filter((x) => {
          let n1 = x.primer_nombre === null ? '' : x.primer_nombre ;
          let n2 = x.segundo_nombre === null ? '' : x.segundo_nombre ;
          let a1 = x.primer_apellido === null ? '' : x.primer_apellido ;
          let a2 = x.segundo_apellido === null ? '' : x.segundo_apellido;
 
           x.nombre = n1 + ' ' + n2 + ' ' + a1 + ' ' + a2;
        });

        r.data.data.suspendido.filter((x) => {
          // CREAR NOMBRE COMPLETO SI LA VARIABLE ES NULL O VACIA NO LA MUESTRA
         let n1 = x.primer_nombre === null ? '' : x.primer_nombre ;
         let n2 = x.segundo_nombre === null ? '' : x.segundo_nombre ;
         let a1 = x.primer_apellido === null ? '' : x.primer_apellido ;
         let a2 = x.segundo_apellido === null ? '' : x.segundo_apellido;

          x.nombre = n1 + ' ' + n2 + ' ' + a1 + ' ' + a2;

        });


        this.usuarios_general = r.data.data.general;
        this.usuarios = this.usuarios_general;
        this.usuarios_activos = r.data.data.activo;
        this.usuarios_pre_cancelados = r.data.data.precancelado;
        this.usuarios_sin_suscripciones = r.data.data.sin_sub;
        this.usuarios_suspendidos = r.data.data.suspendido;

        this.loading = false;
      } catch (error) {
        this.$toast.error(
          "Ocurrió un error al obtener los datos de los usuarios"
        );
        console.log(error);
        this.loading = false;
      }
    },

    async seleccionTab(tipo) {
      if (tipo == 'general') {
        this.usuarios = this.usuarios_general;
      } else if (tipo == 'activos') {
        this.usuarios = this.usuarios_activos;
      } else if (tipo == 'suspendidos') {
        this.usuarios = this.usuarios_suspendidos;
      } else if (tipo == 'pre_cancelados') {
        this.usuarios = this.usuarios_pre_cancelados;
      } else if (tipo == 'sin_suscripcion') {
        this.usuarios = this.usuarios_sin_suscripciones;
      }
    }
  },
};